import React from "react";

import { Icon } from "../../../../shared/Icon/Icon";
import { Tooltip } from "../../../../shared/Tooltip/Tooltip";

import "./LocationDevice.scss";

interface Props {
  hasLocation: boolean;
  locationPathItems: string[];
  locationError?: boolean;
}

export const LocationDevice = ({
  hasLocation,
  locationPathItems,
  locationError = false,
}: Props) => {
  if (locationError) {
    return (
      <div className="LocationDevice__path">
        <Icon
          icon="location-rounded"
          className="LocationDevice__locationIcon"
        />
        <span className="LocationDevice__text">Couldn't fetch location</span>
      </div>
    );
  }

  if (!hasLocation || locationPathItems.length === 0) {
    return (
      <div className="LocationDevice__path">
        <Icon
          icon="location-rounded"
          className="LocationDevice__locationIcon"
        />
        <span className="LocationDevice__text">No location assigned</span>
      </div>
    );
  }

  return (
    <div className="LocationDevice__tooltip">
      <Tooltip
        position="bottom"
        content={
          <span className="LocationDevice__tooltipContent">
            {locationPathItems.map((item, index) => (
              <React.Fragment key={`tooltip-${item}-${index}`}>
                <span>{item}</span>
                {index < locationPathItems.length - 1 && (
                  <Icon
                    icon="arrow-right"
                    className="LocationDevice__tooltipArrowIcon"
                  />
                )}
              </React.Fragment>
            ))}
          </span>
        }
      >
        <div className="LocationDevice__path">
          <Icon
            icon="location-rounded"
            className="LocationDevice__locationIcon"
          />

          <span className="LocationDevice__text">
            {locationPathItems.map((item, index) => (
              <React.Fragment key={`${item}-${index}`}>
                <span className="LocationDevice__segment">{item}</span>
                {index < locationPathItems.length - 1 && (
                  <Icon
                    icon="arrow-right"
                    className="LocationDevice__arrowIcon"
                  />
                )}
              </React.Fragment>
            ))}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};
